import controller from './carousel-category.controller';
import templateBase from './views/carousel-category-base.view.html';
import templateT1 from './views/carousel-category.view-t1.html';
import templateT6 from './views/carousel-category.view-t6.html';


let CarouselCategoryComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@',
        type: '@',
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if (response.CAROUSEL_CATEGORY.component == 'template_t1') {
        return templateT1;
    } else if (response.CAROUSEL_CATEGORY.component == 'template_t6') {
        return templateT6;
    } else {
        return templateBase;
    }
}

export default CarouselCategoryComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/carousel-category/carousel-category.component.js
 **/